export const en = {
  'header': {
    'premium': 'Home',
    'about_us': 'About us',
    'blog': 'Blog',
    'consultation': 'Learn more',
    'alert_button': 'New website'
  },
  'banner': {
    'title': 'is now part of',
  },
  'story': {
    'title': 'Let’s beat the odds',
    'text': 'I was married, divorced and re-married.  It took me awhile to finally live the life I want.  With so many personal experiences, I understand it takes time to meet the right one.  And I know there is a lot people out there are still looking for the true love.<br /><br />After witnessing so many single friends having hard time in finding the right partner, I think it is time for me to use my academic background in study of Interpersonal communication and my experiences in dating and relationships to develop a better solution for all my single friends and others alike.<br /><br />In Aimm, we have our proprietary dating planner system to personalize each of the matching experiences.  More importantly we have the the most passionate dating planners who are ready to be the best teammate and cheerleader for you to find the Mr./ Mrs.Right.<br/><br/>Let’s beat the odds and find the love together.',
    'aimm_founder': 'Aimm founder',
    'about_Ti': 'About Tilaine',
    'profile1': 'New York University M.A. in Speech and Interpersonal Communication',
    'profile2': 'Matchmaking Institue cerfited matchmaker',
    'profile3': 'Columnist for GQ Taiwan, The News Lens and Global Views Monthly 遠見雜誌'
  },
  'price': {
    'title': 'Dating Success Program',
    'basic_title': 'Professional',
    'advanced_title': 'Exclusive',
    'prestigious_title': 'Prestigious',
    'basic_slogan': 'Meet with your <br/>Qualified matches',
    'advanced_slogan': 'Check the porfile <br/>Before meetup',
    'prestigious_slogan': 'Pick up your own dates<br/> Full privacy control',
    'basic_info1': '- 3 meetups in 6 months',
    'basic_info2': '- Create your personal profile',
    'basic_info3': '- Set up the date',
    'basic_info4': '- Only match you with<br /> qualified candidates',
    'advanced_info1': '- 3 meetups in 6 months',
    'advanced_info2': '- Create your personal profile',
    'advanced_info3': '- Set up the date',
    'advanced_info4': '- Only match you with<br/> qualified candidates you said Yes',
    'prestigious_info1': '- 3 meetups in 6 months',
    'prestigious_info2': '- Create your personal profile',
    'prestigious_info3': '- Set up the date',
    'prestigious_info4': '- Check out our database for<br />Your own date',
    'elite_title': 'Membership',
    'elite_info': 'Joining Aimm matching database',
    'elite_btn': 'Sign Up Now',
    'elite_text1': '- Create your personal profile',
    'elite_text2': '- Accessible to be matched',
    'elite_text3': '- Set up the date',
    'consultation_btn': 'To know more',
    'currency_tw': 'TWD',
    'currency_us': 'USD',
    'bilingual': '＊Additional Bilingual service is upon request'
  },
  'status': {
    'title': '',
    'subtitle': '  Service Features',
    'database': 'Matching database',
    'person': '+',
    'male_age': 'Male 25-50',
    'female_age': 'Female 25-45',
    'country_text': 'Aimm matching success rate',
    'language_text': '99% users understand mandarin<br>75% users are bilingual ',
    'education_text': 'Have bachelor’s degree<br/> or higher',
    'match_text': 'Have study or living<br> aboard background',
  },
  'media': {
    'big_title': 'In The News',
    'small_title': ''
  },
  'callToAction': {
    'title': 'Tell us about who you are looking for',
    'gender': 'Gender',
    'age': 'Age range',
    'to': 'to',
    'preferLocation': 'Prefer location',
    'otherPrefer': 'Others',
    'submitConsultation': 'Next',
    'secondTitle': 'Let\'s know more about you',
    'firstName': 'First Name',
    'lastName': 'Last Name',
    'birth': 'Birth year',
    'myGender': 'Gender',
    'male': 'Male',
    'female': 'Female',
    'country': 'Country',
    'zone': 'Location',
    'communication': 'IM',
    'account': 'ID',
    'country_code': 'Country code',
    'phone': 'Contact',
    'email': 'Email',
    'note': 'Note',
    'email_error': 'Please provide the completed email address',
    'error': 'Please fill out the form',
    'number_error': 'Input number (i.e. 1,2 or 3)only',
    'submit': 'Done',
    'cancel': 'Cancel',
    'look_for': 'You are looking for',
    'single': 'Single',
    'divorce': 'Divorced',
    'separated': 'Separated',
    'widow': 'Widowed',
    'marriage': 'Married',
    'elite_title': 'Sign up for Aimm database',
    'marital_status': 'Marital status',
    'thank': 'Got your reservation!<br/>In Aimm, we value each of our clients.<br />Our representative will contact you directly.',
    'thank2': 'Got your reservation! In Aimm, we value each of our clients. Our representative will contact you directly.'
  },
  'about_ti': {
    'resume1': 'Matchmaking Institute certified matchmaker',
    'resume2': 'New York University M.A.in Speech and Interpersonal Communication',
    'resume3': 'Columnist for GQ Taiwan, The News Lens and Global Views Monthly 遠見雜誌',
    'cofounder': 'Aimm cofounder',
    'big_title': 'Modern matchmaker',
    'text': 'Sometimes people say love can\'t be predicted, you can only wait for the serendipity. And that is what Hollywood has been telling us.<br /><br />But in Aimm we believe people can find love in a more efficient way. <br/> With the in-depth consultation, we execute the full scope of client assesment.<br /><br />By sorting, analyzing and establishement, we visualize your ideal life with proper partner criteria.  With Aimm\'s proprietary  \'Engineering behind Matching\', derived from Matchmaking institute\'s best practice alone with sociology, anthopology and psychology methodology, we develop our proprietary matching system to match people with diversity and with efficiency.'
  },
  'match_story': {
    'title': 'Matching Stories',
    'matchmaker': 'Dating planner',
    'meet_id': 'Meetup ID',
    'story_title1': 'Determination for love',
    'story_text1': 'Client C (female, 37yo) used to have a great career in China, however she had difficulty in finding the right partner. In order to change the situation, she even quit her job and moved back to Taiwan. Before coming to Aimm, she went to many different matchmakers. But most of them either turn her down or ask her to lower the expectation to the partner. During our consultation, I understand why she had that kind of expectation. So I just ask her be a little bit more patience.  Luckily, it didn’t take long for her to meet her second match. And they finally got married.',
    'story_title2': 'Serious relationship',
    'story_text2': 'When people take thing serious enough, things can go really fast. During our consultation, both Client B (Male, 39yo) and Client D (Female,35 yo) mentioned they are looking for someone serious relationship.Once they found potential someone, both of them are willing to make a trip to visit the match directly. Fortunately, they met each other.A week after their meetup, client B booked a trip to New York and visit her.',
    'story_title3': 'Just need to find the right one',
    'story_text3': 'Client L (Male, 39yo) usually spend 6 months in California and another 6 months in Taiwan to run his company. I still remember every time when I want to schedule a premium session with him, we always need to reschedule couple times before we actually meet up. I was worried if I found him someone, would he be able to go out date with her. Foruntely, I found someone who share a lot of common ground with him. Because he feel this is the right girl for him, he finally have some time to date. I guess you just need to find the right one and people are willing to spend time and efforts on it.',
    'story_title4': 'The definition of chemistry',
    'story_text4': 'Sometimes people think it is hard to have a relationship when the woman is older than the man. When I arrange a meetup for my female client (34 yo) with a male candidate (32 yo), she was worried that it would be hard to find the chemistry between them. However, when I made the short introduction for them, I specifically mentioned they both studied in the U.S. before. Once I brought up the topic, it seems like they have a lot to share. And obviously those topics are the good old memory that make them really hit it off. End up the guy bought her to dinner right after the meetup.',
    'story_title5': 'An almost missed match',
    'story_text5': 'Our 5pm meetup was set with an unexpected afternoon thundershower started raining at 4pm. Client P (Male, 32yo)was worried about the traffic, so he decided to arrive earlier around 4:30pm, without changing his casual sportswear. In the meantime, the Client E (Female,29 yo) insisted to go to salon before coming to the meetup, so she ended up arriving 30 minutes late.<br /><br />During that 60 minutes waiting for the girl arrive, I was really nervous.Glad that both of my clients were pretty chilled and understandable, and they  liked each other.By the end of the meetup, we all agree it is a great meetup because both of them used their own way to show their respect to the meetup and to each other.',
    'story_title6': 'A sweet gesture',
    'story_text6': 'Last Sunday I arranged a meetup for Client M (Female,36yo) in Taichung. Candidate N (Male,37yo) is living in Taipei but told me he is willing to meet my client in Taichung for her convenience. Such a thoughtful move gave me a really good feeling about the match. At the same time, my female client suggested to find some place close to the train station to avoid any additional traveling for the guy. That is another really sweet gesture. Just as I expected, it\'s a successful match for both of them and they are currently in the relationship!'
  },
  'footer': {
    'about_aimm': 'About Aimm',
    'about_us': 'About us',
    'media': 'Media',
    'blog': 'Blog',
    'join_us': 'Join us',
    'social_media': 'Social media',
    'contact_us': 'Contact us',
    'legal': 'Legal',
    'privacy': 'Terms of Service & Privacy Policy',
    'agreement': 'General Terms of Aimm Premium Service Agreement',
    'more': 'More details',
    'facebook': 'Facebook',
    'partnership': 'Partnership',
    'copyright': 'Copyright © 2018 Lunch Actually Taiwan Co., Ltd. All rights reserved'
  },
  'about': {
    'youtube_title': 'Let\'s find you a right partner to<br/>Share the laughs and tears with.',
    'youtube_info1': 'We understand how wonderful it could be to have a great partner in life.  However, it is always hard to find the compatible one due to individual differences.  Therefore, we develop \'Engineering behind Matching\' to make sure we understand your background, your expectations and who could be compatible with you.',
    'youtube_info2': 'With \'Engineering behind Matching\', derived from Matchmaking institute\'s best practice alone with sociology, anthopology and psychology methodology, we develope our proprietary matching system to match people with diversity and with efficiency.',
    'aimm': 'Why I should join Aimm? ',
    'system_title': 'Proprietary \'Engineering behind Matching',
    'system_info': 'Derived from Matchmaking institute\'s best practice alone with sociology, anthopology and psychology methodology, we develope our proprietary matching system to match people with diversity and with efficiency.',
    'human_title': 'Catering for global ethnic and culturally Chinese singles',
    'human_info': 'We believe love is everywhere and so is Chinese.  So we want to help Chinese singles everywher to find love of their lives.',
    'heart_title': 'Only match those who are mutually interested',
    'heart_info': 'We only match with qualified candidates who are also interested in meeting you. Having a click is easy!'
  },
  'story_card': {
    'title': 'To know more <br/> about our success story'
  }
}
